// @flow
/**
 * @see src/components/utils/icon/icons.js l40
 */
const ACCOMMODATION_COMFORT_ORDER = [
  '000017', // club
  '000048', // club seaside view
  '000061', // superior
  '000018', // deluxe
  '000039', // deluxe zen
  '000047', // deluxe seaside view
  '000056', // Deluxe Exclusive
  '000019', // suite
  '000020', // suite 5 tridents
];

const SINGLE_ROOM = 'simpleRoom';
const SEPARATE_ROOMS = 'separatedRooms';
const CONNECTING_ROOMS = 'simpleRooms';
const SEPARATE_ROOMS_3 = 'separatedRooms3';

const CORRESPONDANCE_ROOM_TYPE = {
  SINGLE_ROOM,
  SEPARATE_ROOMS,
  CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS,
};

const CORRESPONDENCE_CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins',
};

const ROOM_TYPE = {
  SINGLE_ROOM,
  SEPARATE_ROOMS,
  CONNECTING_ROOMS,
  SEPARATE_ROOMS_3,
};

const CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins3',
};

const VILLETA_ROOM_REGEX = new RegExp(/^(B2|B2\+|B2T)+$/);

export {
  ACCOMMODATION_COMFORT_ORDER,
  CORRESPONDANCE_ROOM_TYPE,
  ROOM_TYPE,
  VILLETA_ROOM_REGEX,
  CORRESPONDENCE_CABIN_TYPE,
  CABIN_TYPE,
};
